export const partnerList = [
    { thumb: require(".././assets/images/newImg/partner-1.png") },
    { thumb: require(".././assets/images/newImg/partner-2.png") },
    { thumb: require(".././assets/images/newImg/partner-3.png") },
    { thumb: require(".././assets/images/newImg/partner-4.png") },
];



// WEBPACK FOOTER //
// ./src/data/partner.js